import { render, staticRenderFns } from "./wikiarticle.vue?vue&type=template&id=a985deb0&scoped=true"
import script from "./wikiarticle.vue?vue&type=script&lang=js"
export * from "./wikiarticle.vue?vue&type=script&lang=js"
import style0 from "./wikiarticle.vue?vue&type=style&index=0&id=a985deb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a985deb0",
  null
  
)

export default component.exports